import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Pressable, StyleSheet } from 'react-native';
import { theme } from '@xbto/design-system';
import { Icon, TextBody } from '../../atoms';
export const BackButton = ({ onPress }) => {
    return (_jsxs(Pressable, { onPress: onPress, style: ({ focused }) => (Object.assign(Object.assign({}, $.pressable), { outlineStyle: focused ? 'none' : undefined })), children: [_jsx(Icon, { name: "ChevronLeft", color: "primary", size: "md" }), _jsx(TextBody, { em: true, color: "primary", style: $.label, children: "Back" })] }));
};
const $ = StyleSheet.create({
    pressable: {
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center',
        columnGap: theme.spacing['1'],
        // @ts-expect-error This is web only
        outlineStyle: 'none',
    },
    label: {
        // @ts-expect-error This is web only
        outlineStyle: 'none',
    },
});
